import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import * as Styled from "./loading.style";
export var LoadingPanel = function () { return (_jsx(Styled.Root, { children: _jsx(Styled.Wrapper, { children: _jsx(Styled.Progress, {}) }) })); };
